module.exports = __webpack_public_path__ + "img/fond.85dcf82c.svg";